import { render, staticRenderFns } from "./KnTicketItem.vue?vue&type=template&id=0fbc589f&"
import script from "./KnTicketItem.vue?vue&type=script&lang=js&"
export * from "./KnTicketItem.vue?vue&type=script&lang=js&"
import style0 from "./KnTicketItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports